import React, { useState, Fragment } from 'react';
import { number, func } from 'prop-types';
import { postUserAvatar } from '../../utilities/userUtil/userUtil';

/**
 * AvatarForm has everything you need to update a user's avatar.
 * @returns {React.component} An avatar form to render.
 */
const AvatarForm = (props) => {
  const userId = props.userId;
  const [activeView, setActiveView] = useState('upload');
  const [file, setFile] = useState('');
  const [imagePreviewUrl, setImagePreviewUrl] = useState('');
  const reader = new window.FileReader();

  /**
   * Handles the change of the avatar upload input.
   * @param {Events.change|{}} event - The change event of the user interaction.
   */
  const handleChange = (event) => {
    event.preventDefault();
    const tempFile = event.target.files[0];
    if (tempFile) {
      reader.onload = () => {
        setFile(tempFile);
        setActiveView('preview');
        setImagePreviewUrl(reader.result);
      };
      reader.readAsDataURL(tempFile);
    }
  }

  /**
   * Handles the form submission.
   * @param event - The form submission event.
   */
  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new window.FormData();
    formData.append('file', file);
    formData.append('adminReason', 'Profile avatar changed');
    const response = await postUserAvatar(userId, formData);
    if (response.error) {
      setActiveView('error');
    } else {
      props.updateProfileDisplay(response);
    }
  }

  /**
   * Render the AvatarForm.
   */
  return (
    <div className="avatar-form-container">
      <form className="avatar-form contain" onSubmit={handleSubmit}>
        {(activeView === 'upload') &&
          <Fragment>
            <div className="section-heading-container">
              <h2 className="section-heading">Profile Image Guidelines</h2>
            </div>
            <ul>
              <li>Images must be under 2MB.</li>
              <li>Images must adhere to our <a href="https://customerservice.globe.com/hc/en-us/articles/360020397632-What-are-the-rules-for-posting-comments-in-forums-articles-or-blogs-">community rules</a>.</li>
            </ul>
            <label htmlFor="imageUrl">
              <span className="button">Upload Image</span>
              <input 
                id="imageUrl"
                name="imageUrl"
                type="file" 
                accept="image/gif, image/jpeg, image/jpg, image/png" 
                onChange={handleChange}
                style={{ display: 'none' }}
              />
            </label>
          </Fragment>
        }
        {(activeView === 'preview') &&
          <Fragment>
            <div>
              <img className="profile-avatar" src={imagePreviewUrl} alt="" />
            </div>
            <button className="button" onClick={this.handleSubmit}>Save Image</button>  
            <button type="button" className="button button--reverse button--border" onClick={() => setActiveView('upload')}>Choose a different image.</button>            
          </Fragment>
        }
        {(activeView === 'error') &&
          <Fragment>
            <div>
              <img className="profile-avatar opacity-50" src={imagePreviewUrl} alt="" />
            </div>
            <p className="center"><b>There was a problem uploading your avatar.</b></p>
            <button type="button" className="button" onClick={() => setActiveView('upload')}>Please try again.</button> 
          </Fragment>
        }
        <button type="button" className="button button--reverse" onClick={props.updateActiveView} name="activity">Cancel</button>
      </form>
    </div>
  );

};

/**
 * Validation on passed-in props.
 * @type {Object}
 */
AvatarForm.propTypes = {
  userId: number,
  updateProfileDisplay: func,
};

export default AvatarForm;



// WEBPACK FOOTER //
// ./src/components/AvatarForm/AvatarForm.js